'use client';

import { c as _c } from "react/compiler-runtime";
import Bgr from '@images/renders/infrastructure_images/Infra_Desktop_Webp/4.webp';
import Bgr_Mob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/4.webp';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useRef } from 'react';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import { list } from './ThirdScreenInfra';
import style from './ThirdScreenInfra.module.scss';
function ThirdScreenGeneralMobile() {
  const $ = _c(2);
  const svgRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={style.thirdScreenTitleMobile} data-scroll={true} data-scroll-speed="1" data-scroll-target="#about"><p>Приходите</p><p>поддержать своих</p><p>чемпионов</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div data-scroll={true} className={style.thirdScreenContainer} ref={svgRef} id="about">{t0}<ul className={style.thirdScreenInfoContainer} data-scroll={true} data-scroll-speed="1" data-scroll-target="#about">{list?.map(_temp)}</ul><ParallaxMedia speed={0.01} offset={-100} end={2000} src={Bgr} src375={Bgr_Mob} className={style.secondScreenImgTwo} alt="image" imagePlug={Bgr} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(item) {
  return <li key={item.id} className={style.thirdScreenInfoBox}><SafeHtmlRenderer tag="div" className={style.thirdScreenInfoDescrip} content={item.text || ""} /></li>;
}
export default ThirdScreenGeneralMobile;